<template>
    <div class="faceted">
      <!--{{checkedFacets}}-->
      <!--{{items}}-->
      <!--<PieChart :data="items" :heartBeat="heartBeat"></PieChart>-->
      <simplert :useRadius='true' :useIcon='false' ref='simplert'></simplert>
      <template v-if="Object.keys(items).length > 0">
        <div class="blockRange row"><h4><span class="capitalize">{{ $t(facet) ? $t(facet) : facet }}</span></h4>
          <template v-if="(Object.keys(items).length > noOfItems) || filterTerm.length > 0" >
            <input v-model.trim="filterTerm" @focus="filterTerm = ''" v-bind:placeholder="$t('findFilterItem')"> <!-- <button @click='filterTerm = ""'>clear</button>-->
          </template>
        </div>
        <div class="row" v-if="checkedFacets.length > 0">
          <div class="tooltipx" >
          <a @click="filter()"><icon name='filter'></icon>({{checkedFacets.length}}) Click to filter</a>
          </div>
        </div>
        <!--<DynamicScroller :items="filteredFactedItem" v-bind:class="{scroller:true, scroll:hasScroll}" :min-item-height= "facet === 'collection' ? 50: 25" >-->
        <!--  <template slot-scope="{item, index, active }">-->
        <!--    <DynamicScrollerItem :item="item" :active="active" :size-dependencies="[item.id]" :data-index="index">-->
        <!--        <input type="checkbox" :id="item.id" :value="item.id" v-model="checkedFacets" :data-id="item.id"></input>-->
        <!--        <a @click="clickCheckBox(item.id)" class="capitalize"> {{item.id}} ({{items[item.id]}})</a>-->
        <!--        <template v-if="facet === 'collection'"><a @click="popup(item.id)"><icon name='info-circle'></icon></a></template>-->
        <!--    </DynamicScrollerItem>-->
        <!--  </template>-->
        <!--</DynamicScroller>-->
        <virtual-list class="virtualList" :size="facet === 'collection' ? 40 : 22" :remain="Math.min(sortedItems.length, 3)" :bench="Math.max(sortedItems.length -3, 0)">
          <div class="row" v-for="(item, index) of sortedItems" :key="index">
            <input type="checkbox" :id="index" :value="item" v-model="checkedFacets" :data-id="index"></input>
            <a class="capitalize" @click="clickCheckBox(item)" > {{item.facet}} ({{item.count}})</a> <template v-if="facet === 'collection'"><a @click="popup(item.facet)" class="clickable"><icon name='info-circle'></icon></a></template>
          </div>
          <!--<div class="row" v-for="(index) in sortedItems" :key="index">-->
          <!--  <div>-->
          <!--    
          <!--  </label></div>-->
          <!--</div>-->
        </virtual-list>
        <!--<template v-if="facet === 'collection'">-->
        <!--  {{sortedItems}}-->
        <!--</template>-->
        <!--<div class="row" v-for="(index) in sortedItems">-->
        <!--  <div>-->
        <!--    <label><input type="checkbox" :id="index" :value="index" v-model="checkedFacets" :data-id="index">-->
        <!--    <a @click="clickCheckBox(index)"><label class="capitalize"> {{index}} ({{items[index]}})</label></a>           <template v-if="facet === 'collection'"><a @click="popup(index)"><icon name='info-circle'></icon></a></template>-->
        <!--  </label></div>-->
        <!--</div>-->
        <!--<template v-if="(!isShowAll) && (filteredItems.length > noOfItems)" >-->
        <!--  <div>-->
        <!--    <label><a @click="isShowAll = true" class="expandFilter">{{$t('show')}} {{filteredItems.length - noOfItems}} {{$t('moreItems')}}</a></label>-->
        <!--  </div>-->
        <!--</template>-->
        <!--<template v-if="isShowAll" >-->
        <!--  <div>-->
        <!--    <label><a @click="isShowAll = false" class="expandFilter"> …{{$t('less')}}</a></label>-->
        <!--  </div>-->
        <!--</template>-->
      </template>
      <!--<span style='display:none'>{{heartBeat}}</span>-->
    </div>
</template>

<script>
// require('intersection-observer')
import Vue from 'vue'
// import VTooltip from 'v-tooltip'
import Simplert from 'vue2-simplert'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/filter'
// import PieChart from './PieChart'

import Icon from 'vue-awesome/components/Icon'
// import VueVirtualScroller from 'vue-virtual-scroller'
// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import virtualList from 'vue-virtual-scroll-list'

Vue.component('icon', Icon)
// Vue.use(VTooltip)
// Vue.use(VueVirtualScroller)

// Fetch the solr fields and fulltext based on the defined fields mapping.
export default {
  name: 'Facet',
  props: ['facet', 'noOfItems', 'info'],
  components: {
    Simplert,
    'virtual-list': virtualList
  },
  i18n: { // `i18n` option
    messages: {
      en: {
        creator: 'author',
        findFilterItem: 'Find filter item',
        show: 'Show',
        moreItems: 'more items',
        less: 'less'
      },
      de: {
        creator: 'autoren',
        language: 'sprache',
        subject: 'Themen',
        date: 'datum',
        collection: 'kollektion',
        findFilterItem: 'Filterelement finden',
        show: 'Zeige',
        moreItems: 'weitere',  // Zeige 905 weitere Gegenstände
        less: 'weniger Gegenstände'
      },
      cn: {
        creator: '作者',
        language: '語言',
        subject: '主題',
        date: '日期',
        collection: '彙集'
      }
    }
  },
  data: function () {
    return {
      checkedFacets: [],
      isShowAll: false,
      filterTerm: '',
      msg: 'Click to filter.'
    }
  },
  methods: {
    clickCheckBox: function (item) {
      if (this.checkedFacets.indexOf(item) > -1) {
        this.checkedFacets = this.checkedFacets.filter(x => x !== item)
      } else {
        this.checkedFacets.push(item)
      }
    },
    popup: function (index) {
      // console.log(index, this.info, this.info[index])
      this.$refs.simplert.openSimplert({hideAllButton: true, showXclose: true, title: this.info[index].title, message: this.info[index].content, type: 'info'})
    },
    filter: function () {
      // console.log(this.checkedFacets)
      this.$emit('select-Facets', this.facet, this.checkedFacets)
    }
  },
  computed: {
    items: function () {
      return this.$store.getters['collections/getFacet'](this.facet)
    },
    hasScroll: function () {
      return this.filteredFactedItem ? this.filteredFactedItem.length > 4 : false
    },
    filteredItems: function () {
      // let items = this.items
      // let filterTerm = this.filterTerm
      // let sortedItems = Object.keys(items).sort(function (a, b) {
      //   return parseInt(items[a]) > parseInt(items[b])
      // }).reverse()
      // if (filterTerm !== '') {
      //   return sortedItems.filter(function (item) {
      //     return item.indexOf(filterTerm) > -1
      //   })
      // } else {
      //   return sortedItems
      // }
    },
    sortedItems: function () {
      let items = this.items
      if (this.filterTerm.length > 0) {
        items = items.filter(x => x.facet.indexOf(this.filterTerm) > -1)
      }
      if (this.isShowAll) {
        return items
      } else {
        // console.log(this.noOfItems)
        // return this.filteredItems.slice(0, this.noOfItems)
        return items.slice(0, this.noOfItems)
      }
    },
    filteredFactedItem: function () {
      let items = this.items
      let filterTerm = this.filterTerm
      let sortedItems = Object.keys(items).sort(function (a, b) {
        return parseInt(items[a]) > parseInt(items[b])
      }).reverse()
      if (filterTerm !== '') {
        return sortedItems.filter(function (item) {
          return item.indexOf(filterTerm) > -1
        }).map(x => { return { id: x } })
      } else {
        return sortedItems.map(x => { return { id: x } })
      }
    }
  },
  watch: {
    checkedFacets: function () {
      // console.log(this.checkedFacets)
      // this.$emit('select-Facets', this.facet, this.checkedFacets)
      // this.$refs.simplert.openSimplert({title: 'Alert Title',message: 'Alert Message', type: 'info'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.virtualList:hover {
 cursor:ns-resize;
}

h4 {
  padding: 0px;
}

/*.faceted {*/
/*  padding-bottom:1em;*/
/*}*/


/* Tooltip container */
.tooltipx {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltipx .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
 
    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
    top: -5px;
    right: 105%; 
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltipx:hover .tooltiptext {
    visibility: visible;
}

.col {
  font-size: small;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

div.row {
  margin-left:0px !important;
  margin-right:0px !important;
}
.capitalize {
  text-transform:capitalize;
}
.checkbox {
  display:none;
}
a {
 color: #b41815 !important;
}
a:hover {
  text-decoration: underline !important;
}

.expandFilter {
  font-weight: 400;
}
/*a label {*/
/*  text-decoration: underline !important;*/
/*}*/

label {
     margin-bottom: 0px; 
}


.scroller {
  min-height: 30px;
  max-height: 90px;
  margin-left: -15px;
  margin-right: 20px;
  /*margin-bottom: 20px;*/
}
 
.user {
  height: 100%;
  /*padding: 0 12px;*/
  display: flex;
  align-items: center;
}

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555; 
}

a.clickable:hover {
  cursor: pointer !important;
}

div.tooltipx:hover {
  cursor: pointer !important;
}

a:hover {
  text-decoration: none !important;
}
</style>
<style>
.simplert {
  text-align: left !important;
}
.simplert__content {
  min-width: 80% !important;
}

@media only screen and (max-width: 768px) {
  .simplert__content {
    width: 80% !important;
  }
}

.simplert__title {
    font-size: 1.5em !important;
}
.fa-icon {
  width: 1em;
  height: 1em; /* or any other relative font sizes */

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/Facet.vue